import React from 'react'
import invertColor from '../../../../../../util/invertColor'

import { DEFAULT_FORM_FIELDS } from '../../../../constants'

import './Preview.scss'

const Preview = ({
    colorTheme,
    fieldsDescription = null,
    fields = [],
    headerText = '',
    descriptionText = '',
    buttonText = '',
    linkPrivacyPolicyLink = '',
}) => (
    <div className="lead-form-form-review">
        {headerText.length ? <div className="header">{headerText}</div> : null}
        {descriptionText.length ? <div className="description">{descriptionText}</div> : null}
        <ul className="fields">
            {fields.map(field => (
                <li key={field.key}>
                    <p>{(fieldsDescription || DEFAULT_FORM_FIELDS)[field.key].label}</p>
                    <div></div>
                </li>
            ))}
        </ul>
        {buttonText.length ? (
            <div className="button-wrapper">
                <button
                    style={{
                        backgroundColor: colorTheme,
                        color: invertColor(colorTheme, true),
                    }}
                >
                    {buttonText}
                </button>
            </div>
        ) : null}
        {linkPrivacyPolicyLink.length ? (
            <div className="privacy">
                <span></span>&nbsp;Agree with&nbsp;
                <a href={linkPrivacyPolicyLink} target="_blank" rel="noopener noreferrer">
                    Privacy Policy
                </a>
            </div>
        ) : null}
    </div>
)

export default Preview
